module.exports = new __parcel__URL__("wind-fc.c707460a.png").toString();